import React from 'react';
import { Button, Dropdown, Form } from 'semantic-ui-react';
import { inputToTimestamp, timestampToInput } from './utils';

const REQUEST_TYPE_OPTIONS = [
  { key: 'all', text: '全部请求', value: '' },
  { key: 'text', text: '文本', value: 'text' },
  { key: 'image', text: '图片', value: 'image' },
  { key: 'video', text: '视频', value: 'video' },
  { key: 'unknown', text: '未知类型', value: 'unknown' },
];

const QUICK_RANGES = [
  { label: '1小时', seconds: 60 * 60 },
  { label: '6小时', seconds: 6 * 60 * 60 },
  { label: '24小时', seconds: 24 * 60 * 60 },
  { label: '7天', seconds: 7 * 24 * 60 * 60 },
  { label: '30天', seconds: 30 * 24 * 60 * 60 },
];

const FilterPanel = ({ filters, onChange, onSearch, onReset, loading }) => {
  const update = (name, value) =>
    onChange({
      ...filters,
      [name]: value,
      ...(name === 'start_timestamp' || name === 'end_timestamp'
        ? { range_seconds: '' }
        : {}),
    });

  const setQuickRange = (seconds) => {
    const end = Math.floor(Date.now() / 1000);
    onChange({
      ...filters,
      start_timestamp: end - seconds,
      end_timestamp: end,
      range_seconds: seconds,
    });
  };

  return (
    <Form className='error-stats-filter'>
      <div className='error-stats-quick-ranges'>
        <span className='error-stats-filter-label'>快捷时间</span>
        <Button.Group size='small'>
          {QUICK_RANGES.map((range) => (
            <Button
              type='button'
              key={range.label}
              onClick={() => setQuickRange(range.seconds)}
            >
              {range.label}
            </Button>
          ))}
        </Button.Group>
      </div>

      <Form.Group widths='equal'>
        <Form.Input
          label='开始时间'
          type='datetime-local'
          value={timestampToInput(filters.start_timestamp)}
          onChange={(event) =>
            update('start_timestamp', inputToTimestamp(event.target.value))
          }
        />
        <Form.Input
          label='结束时间'
          type='datetime-local'
          value={timestampToInput(filters.end_timestamp)}
          onChange={(event) =>
            update('end_timestamp', inputToTimestamp(event.target.value))
          }
        />
        <Form.Field>
          <label>请求类型</label>
          <Dropdown
            selection
            fluid
            options={REQUEST_TYPE_OPTIONS}
            value={filters.request_type}
            onChange={(_, { value }) => update('request_type', value)}
          />
        </Form.Field>
        <Form.Input
          label='模型名称'
          placeholder='全部模型'
          value={filters.model_name}
          onChange={(event) => update('model_name', event.target.value)}
        />
      </Form.Group>

      <Form.Group widths='equal'>
        <Form.Input
          label='渠道 ID'
          type='number'
          min='0'
          placeholder='全部渠道'
          value={filters.channel_id}
          onChange={(event) => update('channel_id', event.target.value)}
        />
        <Form.Input
          label='HTTP 状态码'
          type='number'
          min='0'
          max='599'
          placeholder='全部状态'
          value={filters.status_code}
          onChange={(event) => update('status_code', event.target.value)}
        />
        <Form.Input
          label='失败码'
          placeholder='错误码或错误类型'
          value={filters.failure_code}
          onChange={(event) => update('failure_code', event.target.value)}
        />
        <Form.Field className='error-stats-filter-actions'>
          <label>&nbsp;</label>
          <Button primary type='button' onClick={onSearch}>
            {loading ? '重新查询' : '查询'}
          </Button>
          <Button type='button' onClick={onReset}>
            重置
          </Button>
        </Form.Field>
      </Form.Group>
    </Form>
  );
};

export default FilterPanel;
